<template>


      <span class="logou_text" v-on:click="logoutMe">{{ $t('logout') }} <b-icon class="card_chevron chevron_logout" icon="chevron-right"></b-icon></span>


</template>

<script>
export default {
  name: "Logout",
  computed: {
    isLogoutAvailable() {
      return !((this.$store.state.jwt == undefined) || (this.$store.state.jwt.length < 1));
    }
  },
  methods: {
    logoutMe() {
      this.$store.dispatch('LOGOUT')
    }
  }
}
</script>

<style scoped>
.card_chevron {
  color: #72003B;
  transform: scale(0.7) translateY(1px);
}
.chevron_logout {

}
.btn_main {
  color: #FFFFFF;
  width: 210px;
  background: #E20074;
  margin-top: 24px;
  place-self: center;
}

.wrapper_centered {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  margin: 0 auto;
}
.logou_text {
  font-family: "TeleNeoLocalRegular";
  -webkit-font-smoothing: antialiased !important;
  text-rendering: optimizeLegibility !important;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #007FAF;
  cursor: pointer;
}
</style>
